import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Heading,
  Icon,
  SimpleGrid,
  Skeleton,
  SkeletonText,
  Text,
  useColorModeValue, // ✅ Import it
} from '@chakra-ui/react';

import DivisionSection from './components/DivisionSection';
import DistrictSection from './components/DistrictSection';
import TehsilSection from './components/TehsilSection';
import VillageSection from './components/VillageSection';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { HiOutlineGlobeAlt } from 'react-icons/hi2';

const RegionDataAdd = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const cardBg = useColorModeValue('white', 'gray.800');
  const cardShadow = useColorModeValue('md', 'dark-lg');
  const pageBg = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <Box p={{ base: 4, md: 8 }}>
        <Skeleton height="40px" mb={6} />
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          <Box>
            <Skeleton height="150px" mb={4} />
            <SkeletonText mt="4" noOfLines={4} spacing="4" />
          </Box>
          <Box>
            <Skeleton height="150px" mb={4} />
            <SkeletonText mt="4" noOfLines={4} spacing="4" />
          </Box>
        </SimpleGrid>
      </Box>
    );
  }

  if (!user) return null;

  return (
    <Box
      pt={{ base: '140px', md: '90px', xl: '90px', sm: '100px' }}
      px={{ base: '4', md: '8' }}
    >
      <Flex px="20px" mb="8px" justifyContent="space-between" align="center">
        <Flex align="center" gap={2}>
          <Icon as={HiOutlineGlobeAlt} boxSize={5} color="#4B80DE" />
          <Text color={textColor} fontSize="22px" fontWeight="bold">
            Region Data
          </Text>
        </Flex>
      </Flex>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        {user.role === 'admin' && (
          <>
            <DivisionSection />
            <DistrictSection />
            <TehsilSection />
            <VillageSection />
          </>
        )}
        {user.role === 'collector' && (
          <>
            <TehsilSection />
            <VillageSection />
          </>
        )}
        {user.role === 'tahsildar' && <VillageSection />}

        {user.role === 'division' && (
          <>
            <DistrictSection />
            <TehsilSection />
            <VillageSection />
          </>
        )}
        {/* {user.role === 'division' && <DivisionSection />} */}
      </SimpleGrid>
    </Box>
  );
};

export default RegionDataAdd;
